import { Button } from '@material-ui/core';
import React, { useState, useEffect, useReducer } from 'react';
import axios from 'axios';
import ConsentCard from '../components/ConsentCard';
import JTextField from '../components/JTextField';
// import { useParams } from 'react-router-dom';
import AlertModal from '../components/AlertModal';
import { colors, api } from '../utils';

const { blue } = colors;
const { playhouseRegistrationUrl } = api;
// const { playhouse: { programmes } } = data;
const consentSections = {
  'Urgent Medical Treatment': [
    {
      text: `I give consent for my child to be given urgent basic medical care, 
      to my child if necessary.`,
    },
    {
      text: `In the event of an emergency I give consent for my child to be taken 
      to a medical facility foremergency treatment.`,
    },
    {
      text: `I agree to bear the full cost in case my child is sent to 
      the hospital due to an emergency.`,
    },
    {
      text: `I agree for my child's details to be provided to the 
      emergency medical facility.`,
    },
  ],
  'Administering Calpol': [
    {
      text: `I give consent for Calpol to be administered to my child if they have a temperature
      of 37.5°C (99.5°F) or above, following the instructions and dosage relating 
      to my child’sage on the Calpol packaging. I understand that I will be contacted 
      before Calpol is given.`,
    },
  ],
  'Administering Antihistamine': [
    {
      text: `I give consent for an antihistamine to be administered to my child 
      if my child is showingsigns of an allergic reaction. I understand that staff 
      will follow the instructions anddosage relating to my child’s 
      age on the medicine’s packaging. I understand I will becontacted 
      before the antihistamine is given.`,
    },
  ],
  'Policies and Procedures': [
    {
      text: `I confirm that I have read and agree to all PlayHouse Policies and terms 
      and conditionsincluding the policies online at www.myjamboreegh.com and policies 
      posted at thefacility or communicated to me.`,
    },
    {
      text: `I confirm that I am fully responsible for all tuition fees and/ or costs 
      relating to mychild at PlayHouse and/ or Jamboree Activity Centre and will 
      bear the same.`,
    },
  ],
  Communication: [
    {
      text: `I hereby give consent to be added to the parent WhatsApp group 
      or othercommunication platform.`,
    },
  ],
  'Data Protection': [
    {
      text: `I hereby consent that PlayHouse may collect, process and use 
      parent/guardian/child'spersonal data for administrative purposes, 
      for communication and other relevant purposes.`,
    },
    {
      text: `I consent to our data being held electronically in the childcare 
      management software towhich PlayHouse has subscribed.`,
    },
  ],
  'Incident Report': [
    {
      text: `I understand that if a member of staff suspects that a child in 
      their care may have beenabused or neglected, PlayHouse has to report their 
      concerns to the appropriatepersons.`,
    },
  ],
  'Video/Photography': [
    {
      text: `I give consent for my child to be photographed/videoed during any 
      event e.g. single andgroup observations, plays, days out etc. I understand 
      that my child's image may appearin other children's photographs, 
      on our website or social media pages.`,
    },
  ],
  'Sunscreen and insect repellent': [
    {
      text: `I will apply 8-hour sun cream protection and insect repellent to my 
      child beforedropping him/her off. I permit staff to apply sun cream, or 
      insect repellent which Ihave provided to my child as necessary during their day. 
      I agree to provide this labelledwith my child’s name.`,
    },
    {
      text: `In the case of my child becoming sun burnt, I permit you to provide 
      any necessary firstaid treatment.`,
    },
    {
      text: `I understand that I will need to provide suitable clothing for my 
      child to wear at thefacility, including non-slip socks.`,
    },
  ],
  'Parental Responsibility': [
    {
      text: `I agree for my child’s information to be discussed via telephone, 
      Whatsapp and email.`,
    },
    {
      text: `I confirm that I have parental responsibility for the above child 
      and will informPlayHouse in writing if another adult is collecting my child 
      on my behalf.`,
    },
  ],
  'Notice Period': [
    {
      text: `I agree to give one month's written notice of withdrawal or pay a 
      month's fees insteadof notice.`,
    },
  ],
};

const initialState = {
  childName: '',
  parentName: '',
  errors: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'reset':
      return initialState;
    case 'update':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const PlayHouseParentConsent = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [hasFormErrors, setHasFormErrors] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState();

  const validateForm = () => {
    setHasFormErrors(false);
    const updatedErrors = [];
    dispatch({ type: 'update', payload: { errors: [] } });
    const consentKeys = [];
    Object.keys(consentSections).forEach(((sec) => {
      consentSections[sec].forEach(({ text }) => consentKeys.push(text));
    }));
    [...consentKeys, 'childName', 'parentName'].forEach((field) => {
      if (!state[field] || state[field]?.trim() === '') {
        updatedErrors.push(field);
      }
    });
    dispatch({ type: 'update', payload: { errors: updatedErrors } });
    if (updatedErrors.length > 0) setHasFormErrors(true);
    return updatedErrors.length < 1;
  };

  const handleFormSubmission = () => {
    if (validateForm()) {
      const data = {
        ...state,
        parentConsentForm: true,
      };
      axios.post(playhouseRegistrationUrl, data)
        // axios.post('http://localhost:4000/controller/register.php', data)
        .then(() => {
          setIsSuccess(true);
          dispatch({ type: 'reset' });
        })
        .catch(() => {
          setIsSuccess(false);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
    setIsSubmitting(false);
  };

  const handleChange = (key, val) => {
    const payload = {};
    payload[key] = val;
    dispatch({ type: 'update', payload });
    let updatedErrors = [];
    const { errors } = state;
    if (
      ['childName', 'parentName']
        .includes(key) && (!val || val.trim() === ''
      )
    ) {
      updatedErrors = errors.includes(key) ? errors : [...errors, key];
    } else {
      updatedErrors = errors.filter((err) => err !== key);
    }
    dispatch({
      type: 'update',
      payload: {
        errors: updatedErrors,
      },
    });
  };

  useEffect(() => {
    if ([false, true].includes(isSuccess)) {
      setShowModal(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <>
      {
        showModal
        && (
          <AlertModal
            success={isSuccess}
            title={isSuccess ? 'Application submitted!' : 'Failed to submit application'}
            message={isSuccess ? 'We\'ll get back to you shortly' : 'Please try again later.'}
            onClick={() => setShowModal(false)}
          />
        )
      }

      <div style={{
        background: 'url(https://www.myjamboreegh.com/images/banners/playgroup-bg.jpg)',
      }}
      >
        <div className="text-center max-w-5xl mx-auto md:pt-10 px-8 pb-20 bg-white">
          <div
            className="text-xl mb-4"
          >
            Parent Consent Form
          </div>
          <div className="md:flex text-left md:gap-x-2">
            <div className="w-full md:w-1/2">
              <JTextField
                label="Child's full name"
                value={state?.childName}
                onChange={
                  (e) => handleChange('childName', e.target.value)
                }
                hasError={state?.errors?.includes('childName')}
                errorMessage="Child's full name is required"
                required
              />
            </div>
          </div>
          <div className="mt-4 text-left">
            {
              Object.keys(consentSections).map((key) => (
                <div key={key} className="mb-8">
                  <p className="text-lg mb-2" style={{ color: blue }}>{key}</p>
                  {
                    consentSections[key].map(({ text }) => (
                      <ConsentCard
                        value={state[text]}
                        text={text}
                        hasError={state?.errors?.includes(text)}
                        onChange={(val) => handleChange(text, val)}
                      />
                    ))
                  }
                </div>
              ))
            }
          </div>
          <div className="md:flex text-left md:gap-x-2">
            <div className="w-full md:w-1/2">
              <JTextField
                label="Parent name"
                hasError={state?.errors?.includes('parentName')}
                onChange={(e) => handleChange('parentName', e.target.value)}
                value={state?.parentName}
              />
            </div>
          </div>

          <div className="text-left mt-4">
            <Button
              disabled={isSubmitting}
              variant="contained"
              color="primary"
              onClick={() => {
                if (!isSubmitting) handleFormSubmission();
              }}
            >
              {
                isSubmitting ? 'Submitting...' : 'Submit form'
              }
            </Button>
            {
              hasFormErrors
              && <p className="text-red-500 text-xs mt-4">Please make sure you have completed the form before submitting.</p>
            }
          </div>

        </div>
      </div>
    </>
  );
};

export default PlayHouseParentConsent;
